<fieldset [formGroup]="form">
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="30px"
    *ngFor="let key of getKeys(); let i = index"
  >
    <mat-form-field>
      <!-- label with lang: -->
      <!-- [label]="title | translate: { lang: getNameByCode(key) | lowercase }" -->
      <app-easy-textarea
        [formControlName]="key"
        [label]="title | translate"
        [rows]="textareaAutosizeMinRows"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>
  </div>
</fieldset>
